module.exports = __webpack_public_path__ + "img/fubo.921f7055.png";